import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import Scroll from '@components/Scroll'
import Spinner from '@components/spinner'
import Header from '@components/Details/Header'
import { formatDateTime } from '@atheneum/api/dist/lib'

class NotificationList extends Component {
  static propTypes = {
    notificationStore: PropTypes.object
  }

  loadMoreNotifications = () => {
    this.props.notificationStore.loadMoreNotifications()
  }

  render () {
    const {
      listLoaded,
      notificationList,
      countAll,
      loadMore
    } = this.props.notificationStore
    if (!listLoaded) return <Spinner />
    return (
      <DocumentTitle title='Notifications | Atheneum Partners'>
        <Scroll>
          <div className='expert-search'>
            <div className='project-wrapper'>
              <Header>
                <div className='info info--noLeft'>
                  <div className='name-status-wrapper'>
                    <h1>Your notifications</h1>
                  </div>
                </div>
              </Header>
              <div className='m-b-xl'>
                {notificationList.length === 0 ? (
                  <p className='empty-message'>
                    You don’t have any notifications yet
                  </p>
                ) : (
                  notificationList.map(notification =>
                    <NotificationItem
                      notification={notification}
                      createdAt={formatDateTime(notification.createdAt, false)} />)
                )}
                {loadMore ? (
                  <Spinner inline />
                ) : (
                  notificationList.length !== countAll && (
                    <div
                      className='Pagination link'
                      onClick={this.loadMoreNotifications}
                    >
                      Load more...
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </Scroll>
      </DocumentTitle>
    )
  }
}

const NotificationItem = ({ notification, createdAt }) => {
  return (
    <div key={notification.id} className='logs__log-container'>
      {notification.link ? (
        <NotificationLink notification={notification} />
      ) : (
        <div>{notification.message}</div>
      )}
      <div className='logs__log-container__log-date'>
        {createdAt}
      </div>
    </div>
  )
}

const NotificationLink = ({ notification }) => {
  const message = <div dangerouslySetInnerHTML={{ __html: notification.message }}></div>

  return notification.link.match('https') ? (
    <a target="_blank" href={notification.link} rel="noreferrer">
      {message}
    </a>
  ) : (
    <Link to={notification.link}>
      {message}
    </Link>
  )
}

export default inject('notificationStore')(observer(NotificationList))
